import React, { FC } from 'react';
import * as classes from './SectionTitle.module.scss';

interface Props {
  subtitle?: string | JSX.Element;
}

const SectionTitle: FC<Props> = ({ children, subtitle }) => {
  return (
    <div className={classes.wrapper}>
      <h2 className={classes.title}>{children}</h2>
      {subtitle && <div className={classes.subTitle}>{subtitle}</div>}
    </div>
  );
};

export default SectionTitle;
